import axios from "axios";
import { attachAuthInterceptors } from "./attachAuthInterceptors";

const apiVotingClient = axios.create({
    baseURL: process.env.REACT_APP_API_VOTING || "http://localhost:8822",
    timeout: 30000
});

attachAuthInterceptors(apiVotingClient);

export default apiVotingClient;
